<template>
  <main class="min-h-screen">
    <router-view />
  </main>
</template>
